// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1vhks","list":"PatternAutocomplete_list__3jIhQ"};